import {createAction} from '@reduxjs/toolkit'
import {LoginFormData, StorageLocationPayload} from 'interfaces'
export const login = createAction<
  LoginFormData & {
    redirectTo: string
  }
>('Login')

export const loginSuccess = createAction('LoginSuccess')
export const loginFailure = createAction('LoginFailure')

export const storageLocation =
  createAction<StorageLocationPayload>('StorageLocation')

export const storageLocationSuccess = createAction('StorageLocationSuccess')
export const storageLocationFailure = createAction('StorageLocationFailure')

export const updateCurrentStep = createAction<number>('updateCurrentStep')
